module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "GFP_Part_H1"
  }, [_vm._v("part one")]), _vm._v(" "), _c('p', {
    staticClass: "GFP_Center"
  }, [_vm._v("...............................")]), _vm._v(" "), _c('h2', {
    staticClass: "GFP_Time_H2"
  }, [_vm._v("before")]), _vm._v(" "), _c('p', {
    staticClass: "GFP_Quote"
  }, [_vm._v("I have loved, O Lord, the beauty of thy house"), _c('br'), _vm._v("and the place where dwelleth thy glory.")]), _vm._v(" "), _c('p', {
    staticClass: "GFP_Quote_Attribution"
  }, [_vm._v("Psalm 26:8")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc1b7f14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1.vue
// module id = 72
// module chunks = 0